function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _this19 = this;

function _toConsumableArray2(arr) { return _arrayWithoutHoles2(arr) || _iterableToArray2(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread2(); }

function _nonIterableSpread2() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _iterableToArray2(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles2(arr) { if (Array.isArray(arr)) return _arrayLikeToArray2(arr); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

function _classCallCheck2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import Vue from 'vue';
import { FlyIn } from '../fly-in';

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var dist = createCommonjsModule(function (module, exports) {
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  function debounce(func, wait, immediate) {
    var timeout;
    var args;
    var context;
    var timestamp;
    var result;

    var later = function later() {
      // 据上一次触发时间间隔
      var last = +new Date() - timestamp; // 上次被包装函数被调用时间间隔last小于设定时间间隔wait

      if (last < wait && last > 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null; // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用

        if (!immediate) {
          result = func.apply(context, args);

          if (!timeout) {
            context = args = null;
          }
        }
      }
    };

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      context = this;
      timestamp = +new Date();
      var callNow = immediate && !timeout; // 如果延时不存在，重新设定延时

      if (!timeout) timeout = setTimeout(later, wait);

      if (callNow) {
        result = func.apply(context, args);
        args = null;
        context = null;
      }

      return result;
    };
  }

  var DictConfig = /*#__PURE__*/function () {
    function DictConfig(list) {
      var _this = this;

      _classCallCheck(this, DictConfig);

      this.map = {};
      this.list = [];
      this.dictValueList = [];
      this._valueMap = {};
      this._listValueMap = {};

      this.getInfo = function (value) {
        if (!_this._valueMap[value] && !_this._listValueMap[value]) {
          // console.error('value值不在初始化数据中')
          return value;
        }

        if (_this._valueMap[value]) {
          return _this._valueMap[value];
        }

        return _this._listValueMap[value];
      };

      if (!Array.isArray(list)) {
        throw new Error('缺少初始化参数或初始化参数不正确');
      }

      this.list = list;
      var map = {};
      var dictValueList = [];
      var listValueMap = {};
      list.forEach(function (item) {
        dictValueList.push(item.value);

        if (item.key) {
          map[item.key] = item;
        }

        _this._valueMap[item.value] = item;

        if (Array.isArray(item.value)) {
          item.value.forEach(function (valueItem) {
            listValueMap[valueItem] = item;
          });
        }
      });
      this._listValueMap = listValueMap;
      this.dictValueList = dictValueList;
      this.map = map;
    }

    _createClass(DictConfig, [{
      key: "custom",
      value: function custom() {
        var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (!list || !Object.values(list).length) {
          var _list = JSON.parse(JSON.stringify(this.list)) || [];

          return {
            changeName: function changeName() {
              var changeConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

              if (!Array.isArray(changeConfig) || !changeConfig.length) {
                throw new Error('缺少自定义参数');
              }

              var values = changeConfig.map(function (item) {
                return item.value;
              });

              _list.map(function (item) {
                if (values.includes(item.value)) {
                  item.name = changeConfig[values.indexOf(item.value)].name;
                }

                return item;
              });

              var newDictConfig = new DictConfig(_list);
              return _objectSpread({
                end: newDictConfig
              }, newDictConfig.custom());
            },
            filterMap: function filterMap() {
              var filterConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

              if (!filterConfig || Array.isArray(filterConfig) && !filterConfig.length) {
                throw new Error('缺少过滤参数');
              }

              if (!Array.isArray(filterConfig)) {
                filterConfig = [filterConfig];
              }

              var newArray = _list.filter(function (item) {
                return !filterConfig.includes(item.value);
              });

              var newDictConfig = new DictConfig(newArray);
              return _objectSpread({
                end: newDictConfig
              }, newDictConfig.custom());
            }
          };
        }

        return new DictConfig(list);
      }
    }, {
      key: "getName",
      value: function getName(value) {
        if (!this._valueMap[value] && !this._listValueMap[value]) {
          // console.error('value值不在初始化数据中')
          return value;
        }

        if (this._valueMap[value]) {
          return this._valueMap[value].name;
        }

        return this._listValueMap[value].name;
      }
    }]);

    return DictConfig;
  }();

  var Queue = /*#__PURE__*/function () {
    function Queue() {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      _classCallCheck(this, Queue);

      this.elements = [];
      this.elements = _toConsumableArray(element);
    }

    _createClass(Queue, [{
      key: "add",
      value: function add(element) {
        if (!element) {
          console.warn('element is undefined, can not add into queue');
          return this;
        }

        if (Array.isArray(element)) {
          this.elements = [].concat(_toConsumableArray(this.elements), _toConsumableArray(element));
        } else {
          this.elements.push(element);
        }

        return this;
      }
    }, {
      key: "del",
      value: function del() {
        this.elements.shift();
        return this;
      }
    }, {
      key: "front",
      get: function get() {
        return this.elements[0] || {};
      }
    }, {
      key: "removeElement",
      value: function removeElement(element) {
        var index = this.elements.findIndex(function (item) {
          return item === element;
        });

        if (index > -1) {
          this.elements.splice(index, 1);
        }
      }
    }, {
      key: "hasElement",
      value: function hasElement() {
        return this.elements.length !== 0;
      }
    }, {
      key: "elementSize",
      get: function get() {
        return this.elements.length;
      }
    }]);

    return Queue;
  }();

  exports.DictConfig = DictConfig;
  exports.Queue = Queue;
  exports.debounce = debounce;
});
unwrapExports(dist);
var dist_1 = dist.DictConfig;
var dist_2 = dist.Queue;
dist.debounce;
var POLLING_DELAY = 8000;
var COUNT_DOWN_TIME = 5;
var MAX_POLLING_TIME = 1000 * 60 * 60 * 5;

var DownloadTask = /*#__PURE__*/function (_dist_) {
  _inherits(DownloadTask, _dist_);

  var _super = _createSuper(DownloadTask);

  function DownloadTask() {
    var _this3 = this;

    var _this2;

    _classCallCheck2(this, DownloadTask);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super.call.apply(_super, [this].concat(args));

    _defineProperty2(_assertThisInitialized(_this2), "tasks", []);

    _defineProperty2(_assertThisInitialized(_this2), "_options", {
      getTasksFun: function getTasksFun() {
        _newArrowCheck(this, _this3);

        return Promise.resolve([]);
      }.bind(this),
      addDownloadTimesFun: function addDownloadTimesFun() {
        _newArrowCheck(this, _this3);

        return Promise.resolve([]);
      }.bind(this),
      getDownloadResultFun: function getDownloadResultFun() {
        _newArrowCheck(this, _this3);

        return Promise.resolve([]);
      }.bind(this)
    });

    _defineProperty2(_assertThisInitialized(_this2), "_countDownHandler", function (handlerItem) {
      var _this4 = this;

      _newArrowCheck(this, _this3);

      Vue.set(handlerItem, 'countDown', function (downloadNow) {
        var _this5 = this;

        _newArrowCheck(this, _this4);

        if (downloadNow) {
          handlerItem.countDownTime = 1;
        }

        var timer = null;
        handlerItem.inCountDown = true;
        timer = setInterval(function () {
          _newArrowCheck(this, _this5);

          // 已经有下载次数的任务,清除定时器,不再自动下载
          if (handlerItem.dlTimes) {
            handlerItem.inCountDown = false;
            clearInterval(timer);
            return;
          }

          handlerItem.countDownTime = handlerItem.countDownTime - 1;

          if (handlerItem.countDownTime === 0) {
            clearInterval(timer);
            handlerItem.inCountDown = false;

            _this2._autoDownload(handlerItem);
          }
        }.bind(this), 1000);
      }.bind(this));
    }.bind(this));

    return _this2;
  }

  _createClass2(DownloadTask, [{
    key: "init",
    value: function init(opt) {
      var _this6 = this;

      if (!opt.getTasksFun || !opt.addDownloadTimesFun || !opt.getDownloadResultFun) {
        throw new Error('需要传入必要的初始化接口函数');
      }

      this._options = _objectSpread2(_objectSpread2({}, this._options), opt);
      _Polling.prototype.getDownloadResultFun = opt.getDownloadResultFun;

      this._options.getTasksFun().then(function (_ref) {
        var _this7 = this;

        _newArrowCheck(this, _this6);

        var data = _ref.data;
        data.list = data.list.map(function (item) {
          _newArrowCheck(this, _this7);

          if (item.args) {
            try {
              item.args = JSON.parse(item.args);
            } catch (e) {
              console.log(e);
            }
          } else {
            item.args = [];
          }

          return item;
        }.bind(this));
        this.tasks = _toConsumableArray2(data.list);
        this.briefTask.forEach(function (item) {
          _newArrowCheck(this, _this7);

          this._createParams(item);
        }.bind(this));
      }.bind(this));
    } // 获取简略列表,当天申请的且未下载的数据

  }, {
    key: "briefTask",
    get: function get() {
      var _this8 = this;

      return this.tasks.filter(function (item) {
        _newArrowCheck(this, _this8);

        return (item.fileStatus === DOWNLOAD_TASK_STATUS.map.generated.value && item.dlTimes < 1 || item.fileStatus === DOWNLOAD_TASK_STATUS.map.inGenerating.value || item.fileStatus === DOWNLOAD_TASK_STATUS.map.submit.value) && item.reqTime > new Date(new Date().toLocaleDateString()).getTime();
      }.bind(this)) || [];
    }
  }, {
    key: "hasPollingTask",
    value: function hasPollingTask() {
      var _this9 = this;

      return this.briefTask.some(function (item) {
        _newArrowCheck(this, _this9);

        return item.fileStatus === DOWNLOAD_TASK_STATUS.map.inGenerating.value || item.fileStatus === DOWNLOAD_TASK_STATUS.map.submit.value;
      }.bind(this));
    }
  }, {
    key: "getTask",
    value: function getTask(serialNo) {
      var _this10 = this;

      return this.tasks.find(function (item) {
        _newArrowCheck(this, _this10);

        return item.serialNo === serialNo;
      }.bind(this));
    }
  }, {
    key: "addTask",
    value: function addTask(task, _ref2) {
      var flyInOptions = _ref2.flyInOptions;

      this._createParams(task);

      if (task.args) {
        try {
          task.args = JSON.parse(task.args);
        } catch (e) {
          task.args = [];
        }
      }

      this.tasks.unshift(task);
      this.createPolling(task);

      if (flyInOptions.el) {
        try {
          FlyIn(flyInOptions);
        } catch (e) {
          console.log(e);
        }
      }
    }
  }, {
    key: "filterArgs",
    value: function filterArgs(args) {
      var _this11 = this;

      return args.filter(function (item) {
        _newArrowCheck(this, _this11);

        return item.split(':')[1].replace(new RegExp(' |null', 'g'), '');
      }.bind(this)) || [];
    }
  }, {
    key: "addDlTime",
    value: function addDlTime(task) {
      var _this12 = this;

      task.dlTimes += 1;

      this._options.addDownloadTimesFun({
        serialNo: task.serialNo
      }).then(function () {
        _newArrowCheck(this, _this12);
      }.bind(this))["catch"](function () {
        _newArrowCheck(this, _this12);
      }.bind(this));

      this.removeElement(task);
    }
  }, {
    key: "_autoDownload",
    value: function _autoDownload(task) {
      window.location.href = task.fileUrl;
      this.del();
      this.addDlTime(task);

      if (this.hasElement()) {
        this._countDownStart(this.front);
      }
    }
  }, {
    key: "manuallyCountdown",
    value: function manuallyCountdown(notDownload) {
      var _this13 = this;

      notDownload.forEach(function (item) {
        _newArrowCheck(this, _this13);

        this._createParams(item);

        this._countDownHandler(item);
      }.bind(this));
      this.add(notDownload);

      this._countDownStart(notDownload[0]);
    }
  }, {
    key: "_createParams",
    value: function _createParams(task) {
      Vue.set(task, 'countDownTime', COUNT_DOWN_TIME);
      Vue.set(task, 'inCountDown', false);
    }
  }, {
    key: "_countDownStart",
    value: function _countDownStart(task) {
      if (!this.front.inCountDown) {
        try {
          task.countDown(this.elementSize === 1);
        } catch (e) {
          console.log(e);
        }
      }
    } // 创建轮询实例

  }, {
    key: "createPolling",
    value: function createPolling(task) {
      var _this14 = this;

      if (task && task.fileStatus === DOWNLOAD_TASK_STATUS.map.generated.value) {
        this._countDownHandler(task);

        this.add(task);

        this._countDownStart(task);

        return;
      }

      var tasks = task ? [Array.isArray(task) ? _toConsumableArray2(task) : task] : this.tasks;
      var inGeneratingTask = tasks.filter(function (item) {
        _newArrowCheck(this, _this14);

        return (item.fileStatus === DOWNLOAD_TASK_STATUS.map.inGenerating.value || item.fileStatus === DOWNLOAD_TASK_STATUS.map.submit.value) && item.reqTime > Date.now() - MAX_POLLING_TIME;
      }.bind(this)) || [];
      inGeneratingTask.forEach(function (item) {
        var _this15 = this;

        _newArrowCheck(this, _this14);

        var query = {
          serialNo: item.serialNo
        };
        var polling = new _Polling({
          others: {
            task: item
          },
          query: query,
          finished: function finished(_ref3) {
            _newArrowCheck(this, _this15);

            var fileUrl = _ref3.fileUrl,
                genrTime = _ref3.genrTime;
            item.fileStatus = DOWNLOAD_TASK_STATUS.map.generated.value;
            item.fileUrl = fileUrl;
            item.genrTime = genrTime;

            this._countDownHandler(item);

            this.add(item);

            this._countDownStart(item);
          }.bind(this),
          fail: function fail() {
            var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            item.fileStatus = DOWNLOAD_TASK_STATUS.map.generateFail.value;

            if (err.remark) {
              item.remark = err.remark;
            }

            console.log(err.msg || '轮询下载任务出现错误');
          }
        });
        polling.start();
      }.bind(this));
    }
  }]);

  return DownloadTask;
}(dist_2);

var DownloadTask$1 = new DownloadTask([]);
/**
 * 轮询异步任务的执行结果
 * @param finished 完成回调
 * @param fail 失败或错误回调
 * @param complete 结束回调
 * @param query 传递的查询参数，target必传
 * @param others
 */

function _Polling(_ref4) {
  var _this16 = this;

  var finished = _ref4.finished,
      fail = _ref4.fail,
      complete = _ref4.complete,
      query = _ref4.query,
      others = _ref4.others;
  var getAsyncTaskResultTimer = null;
  var pollingTime = 0;

  this.clean = function () {
    _newArrowCheck(this, _this16);

    clearTimeout(getAsyncTaskResultTimer);
  }.bind(this);

  pollingTime = others.task.reqTime;

  this.start = function () {
    _newArrowCheck(this, _this16);

    return _poll();
  }.bind(this);

  var _poll = function poll() {
    var _this17 = this;

    _newArrowCheck(this, _this16);

    this.getDownloadResultFun(query).then(function (_ref5) {
      var _this18 = this;

      _newArrowCheck(this, _this17);

      var data = _ref5.data;
      var fileStatus = data.fileStatus;
      others.task.fileStatus = fileStatus;

      if (fileStatus === DOWNLOAD_TASK_STATUS.map.generated.value) {
        finished && finished(data);
        setTimeout(function () {
          _newArrowCheck(this, _this18);

          complete && complete(data);
        }.bind(this));
      } else if (fileStatus === DOWNLOAD_TASK_STATUS.map.generateFail.value) {
        clearTimeout(getAsyncTaskResultTimer);
        fail && fail(data);
      } else {
        clearTimeout(getAsyncTaskResultTimer);
        getAsyncTaskResultTimer = setTimeout(function () {
          _newArrowCheck(this, _this18);

          _poll();
        }.bind(this), POLLING_DELAY);
      }
    }.bind(this))["catch"](function (err) {
      _newArrowCheck(this, _this17);

      fail && fail(err);
      complete && complete();
    }.bind(this))["finally"](function () {
      _newArrowCheck(this, _this17);

      if (pollingTime < Date.now() - MAX_POLLING_TIME) {
        clearTimeout(getAsyncTaskResultTimer);
      }
    }.bind(this));
  }.bind(this);
}

var DOWNLOAD_TASK_STATUS = new dist_1([{
  key: 'submit',
  value: 0,
  name: '任务已提交'
}, {
  key: 'inGenerating',
  value: 1,
  name: '文件生成中'
}, {
  key: 'generated',
  value: 2,
  name: '文件已生成'
}, {
  key: 'generateFail',
  value: 3,
  name: '文件生成失败'
}]); //

var script = {
  name: 'DownloadCenter',
  props: {
    downloadCenterStyle: {
      type: String,
      "default": ''
    },
    options: {
      type: Object,
      "default": function _default() {
        var _this20 = this;

        _newArrowCheck(this, _this19);

        return {
          getTasksFun: function getTasksFun() {
            _newArrowCheck(this, _this20);

            return Promise.resolve([]);
          }.bind(this),
          addDownloadTimesFun: function addDownloadTimesFun() {
            _newArrowCheck(this, _this20);

            return Promise.resolve([]);
          }.bind(this),
          getDownloadResultFun: function getDownloadResultFun() {
            _newArrowCheck(this, _this20);

            return Promise.resolve([]);
          }.bind(this)
        };
      }.bind(this)
    }
  },
  data: function data() {
    return {
      DOWNLOAD_TASK_STATUS: DOWNLOAD_TASK_STATUS,
      DownloadTask: DownloadTask$1,
      showDialog: false,
      tasks: [],
      downloadTask: null
    };
  },
  mounted: function mounted() {
    this.init();
  },
  computed: {// pollingTasks() {
    //   return DownloadTask.tasks.filter(
    //     item =>
    //       item.fileStatus === DOWNLOAD_TASK_STATUS.map.inGenerating.value ||
    //       item.fileStatus === DOWNLOAD_TASK_STATUS.map.submit.value
    //   ) || []
    // }
  },
  methods: {
    dateFmt: function dateFmt(time, fmt) {
      if (!time) {
        return '-';
      }

      var value = new Date(time);
      var o = {
        'M+': value.getMonth() + 1,
        //  月份
        'd+': value.getDate(),
        //  日
        'h+': value.getHours(),
        //  小时
        'm+': value.getMinutes(),
        //  分
        's+': value.getSeconds(),
        //  秒
        'q+': Math.floor((value.getMonth() + 3) / 3),
        //  季度
        S: value.getMilliseconds() // 毫秒

      };

      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (value.getFullYear() + '').substr(4 - RegExp.$1.length));
      }

      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }

      return fmt;
    },
    handleClick: function handleClick() {
      this.showDialog = true;
    },
    init: function init() {
      var _this21 = this;

      DownloadTask$1.init(this.options);
      DownloadTask$1.createPolling();
      var notDownload = DownloadTask$1.briefTask.filter(function (item) {
        _newArrowCheck(this, _this21);

        return item.fileStatus === DOWNLOAD_TASK_STATUS.map.generated.value && item.dlTimes < 1;
      }.bind(this)) || [];

      if (notDownload.length) {
        this.$confirm("\u8FD1\u671F\u60A8\u6709".concat(notDownload.length, "\u4EFD\u672A\u4E0B\u8F7D\u7684\u6570\u636E\u6587\u4EF6\uFF0C\u7CFB\u7EDF\u5DF2\u5904\u7406\u5B8C\u6210\uFF0C\u9700\u8981\u73B0\u5728\u4E0B\u8F7D\u5417\uFF1F"), '提示', {
          confirmButtonText: '现在下载',
          cancelButtonText: '稍后',
          customClass: 'resetMessageBox'
        }).then(function () {
          _newArrowCheck(this, _this21);

          DownloadTask$1.manuallyCountdown(notDownload);
        }.bind(this));
      }
    }
  },
  watch: {}
};
var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAYFBMVEVHcEz+vWv/vGj+u2j/uGb+vWv+vWv/r1D/u2f/rkz+vGj+vWr+u2f+u2j+vGv+vWv/rkv/rkz9vWz////+uWX/+fL+wnn/+/f/69P+5Mf+6M/+xoD+yon/8+X/2a7/tFmrEryoAAAAEXRSTlMA5DKNCfDWIRbdwPp0qVpH9MRxaeoAAAEdSURBVEjH1dfJcoQgEIBhQRbjAiPBLaPw/m+ZHstLHKKkqYrlf/8uVNtClt02lj/aP/Zo5IbrFlG54Q8MbosULH9ib/rzfBh7N0XkTBDPX1G5IHZjVM4HsOuGqLrJvmH3Gd3id9gv8bjrd9j+G37eHbNixWP33nCGi1JU1lrzDOWGE8zNQfNyjIk51GMCNv10hIU5ye3PcVknjBYx2PTzLgMnbEVJ4bQNNpWCdcbwmGaswdoqBfMUTCT85bBYwJhcg0sYsToJV1fgBrDiWMwScJ6KNRrDKtEEiWvAFImr67ACLAXyc1ZRu/cXrFMxE+gtBCVh5O4l698duQHJemdG7iHBXlhy9IBBCjFjPGfbO4Hm5HUviY83mt33QfYNVcvapF3x7ZYAAAAASUVORK5CYII=";
var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAjVBMVEVHcEwajP8cjP8zMzMyMjIyMjIyMjIyMjIzMzMvLy8yMjIZjP8yMjIyMjIcjP8YGBgyMjIbjP8tLS0AgP8zMzMuLi4yMjIxMTExMTEyMjIyMjIZjP8bjP8yMjIxMTEyMjIzMzMxMTEyMjIbjP8yMjIyMjIyMjIWi/8bjP8ZjP8wMDAxMTEXif8ajP8yMjJKXJAtAAAALnRSTlMAJuSn0PYigGcL8BT7vt0El+4WBewsOllN4tpU+0MztpJ7yrp5cpwbZUMqajF9I7pFFQAAAUZJREFUOMvdksmSgjAQQFFZTAwTA44xYVNQEZf8/+cN2QhWyVg15WneiW4edKc7nvcn2tV7Z9U06Vtp9jVf/TcJA4WTdIyfnGghOV+ttD2rxHEsbZGQwMJKFKpEEI6kPYrCnsSVS2S8RwfnJP6mVA+plfRmdhsfDFIfqBZnTaelrGnNx1vXttAd3gnpeqnN8vnMtHGyEohNg+mFkMecPAjJdL1SLGy9EFbmKb3kJM8Hx8M+s+c7CTq0l0kpG8LhFebMjUNWzNytC2FsJukKS6u7j24miJH+wV7UawUdL2Gpc745eC0CBQoK51CEdFboQ/mQfkuOAS+tU3B4U8mbacqOFSwQp4mCMnTGZhnPEgYRE8zv2Qh+BN5LqdfKKOaM8fhwxd6U9ILPSzUspiVqlr9GVTRJjCJ9eWvxC5WZBd4tJymw90l+AIuNIsdcGpiQAAAAAElFTkSuQmCC";

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}
/* script */


var __vue_script__ = script;

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", [_c("div", {
    staticClass: "yx-download-center",
    style: _vm.downloadCenterStyle
  }, [_c("el-popover", {
    ref: "popover",
    attrs: {
      placement: "left",
      width: "330",
      "popper-class": "yx-download-center-popover",
      trigger: "hover"
    }
  }, [_c("div", [_c("div", {
    staticClass: "yx-download-popper-title",
    on: {
      click: _vm.handleClick
    }
  }, [_vm._v("进行中")]), _vm._v(" "), _c("div", {
    staticClass: "yx-download-popper-content"
  }, [_c("div", {
    staticClass: "yx-download-task-container"
  }, [_vm.DownloadTask.briefTask.length ? _vm._l(_vm.DownloadTask.briefTask, function (item) {
    return _c("div", {
      key: item.serialNo,
      staticClass: "yx-download-task"
    }, [_c("img", {
      staticClass: "yx-download-task-icon",
      attrs: {
        src: img$1,
        alt: ""
      }
    }), _vm._v(" "), _c("div", {
      staticClass: "yx-download-task-info"
    }, [_c("el-tooltip", {
      attrs: {
        effect: "dark",
        content: item.fileName,
        placement: "top"
      }
    }, [_c("div", {
      staticClass: "yx-download-task-file-name"
    }, [_vm._v("\n                      " + _vm._s(item.fileName) + "\n                    ")])]), _vm._v(" "), _c("div", {
      staticClass: "yx-download-task-status"
    }, [_vm._v("\n                    " + _vm._s(_vm.DOWNLOAD_TASK_STATUS.getName(item.fileStatus)) + "\n                  ")])], 1), _vm._v(" "), _c("div", {
      staticClass: "yx-down-task-action"
    }, [item.inCountDown ? [_vm._v("\n                    " + _vm._s(item.countDownTime) + "s\n                  ")] : [item.fileStatus === _vm.DOWNLOAD_TASK_STATUS.map.generated.value ? _c("a", {
      staticClass: "yx-download-btn-link",
      attrs: {
        href: item.fileUrl
      },
      on: {
        click: function click($event) {
          return _vm.DownloadTask.addDlTime(item);
        }
      }
    }, [_vm._v("\n                      下载\n                    ")]) : [_vm.DOWNLOAD_TASK_STATUS.map.submit.value, _vm.DOWNLOAD_TASK_STATUS.map.inGenerating.value].includes(item.fileStatus) ? _c("span", [_c("i", {
      staticClass: "el-icon-loading",
      staticStyle: {
        color: "#1C8CFF"
      }
    })]) : _vm._e()]], 2)]);
  }) : [_c("div", {
    staticClass: "yx-download-empty"
  }, [_c("div", {
    staticClass: "el-icon-files yx-download-icon-files"
  }), _vm._v(" "), _c("div", [_vm._v("暂无文件")])])]], 2)])]), _vm._v(" "), _c("div", {
    ref: "entry",
    staticClass: "yx-download-main-btn",
    attrs: {
      slot: "reference",
      id: "downLoadEntry"
    },
    on: {
      click: _vm.handleClick
    },
    slot: "reference"
  }, [_c("div", {
    staticClass: "yx-download-box"
  }, [_c("div", {
    staticClass: "yx-download-entry"
  }, [_c("div", {
    staticClass: "yx-download-down-icon",
    "class": {
      on: _vm.DownloadTask.hasPollingTask(),
      wait: !_vm.DownloadTask.hasPollingTask() && _vm.DownloadTask.briefTask.length
    }
  }, [_c("img", {
    attrs: {
      src: img,
      alt: ""
    }
  })])])])])])], 1), _vm._v(" "), _c("el-dialog", {
    attrs: {
      width: "1200px",
      "append-to-body": "",
      center: true,
      title: "下载中心",
      "custom-class": "customDialogClass",
      visible: _vm.showDialog
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.showDialog = $event;
      }
    }
  }, [_c("div", {
    staticClass: "yx-download-table-tip"
  }, [_vm._v("\n      下载记录\n      "), _c("span", [_vm._v("（温馨提示：文件只保存15天，过期后不展示）")])]), _vm._v(" "), _c("el-table", {
    staticClass: "custom-el-table-border",
    attrs: {
      height: "360px",
      "header-row-class-name": "custom-el-table-th",
      "empty-text": "暂无生成的文件记录",
      data: _vm.DownloadTask.tasks
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      align: "center",
      width: "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      label: "申请时间",
      width: "100px",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v("\n            " + _vm._s(_vm.dateFmt(scope.row.reqTime, "yyyy-MM-dd hh:mm:ss")) + "\n          ")])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      label: "数据来源",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.category))]), _vm._v(" "), _c("div", [_vm._v(_vm._s(scope.row.feature))])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      label: "筛选条件",
      align: "left",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-popover", {
          attrs: {
            placement: "top-start",
            title: "",
            width: "200",
            trigger: "hover"
          }
        }, [_c("div", {
          staticClass: "yx-download-center-arg"
        }, _vm._l(scope.row.args, function (item) {
          return _c("div", {
            key: item
          }, [_vm._v("\n                " + _vm._s(item) + "\n              ")]);
        }), 0), _vm._v(" "), _c("div", {
          staticClass: "arg-desc",
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, _vm._l(scope.row.args, function (item) {
          return _c("div", {
            key: item
          }, [_vm._v("\n                " + _vm._s(item) + "\n              ")]);
        }), 0)])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "fileName",
      label: "文件名称",
      align: "center"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      label: "完成时间",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v("\n            " + _vm._s(_vm.dateFmt(scope.row.genrTime, "yyyy-MM-dd hh:mm:ss")) + "\n          ")])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      label: "文件状态",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [!scope.row.dlTimes ? _c("span", [_vm._v("\n            " + _vm._s(_vm.DOWNLOAD_TASK_STATUS.getName(scope.row.fileStatus)) + "\n          ")]) : _c("span", [_vm._v("\n            文件已下载\n          ")])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      label: "操作",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.inCountDown ? [_vm._v("\n            " + _vm._s(scope.row.countDownTime) + "s后下载\n          ")] : [scope.row.fileStatus === _vm.DOWNLOAD_TASK_STATUS.map.generated.value ? _c("a", {
          staticClass: "yx-download-btn-link",
          attrs: {
            href: scope.row.fileUrl
          },
          on: {
            click: function click($event) {
              return _vm.DownloadTask.addDlTime(scope.row);
            }
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.dlTimes ? "重新下载" : "下载") + "\n            ")]) : [_vm.DOWNLOAD_TASK_STATUS.map.submit.value, _vm.DOWNLOAD_TASK_STATUS.map.inGenerating.value].includes(scope.row.fileStatus) ? _c("span", [_c("i", {
          staticClass: "el-icon-loading",
          staticStyle: {
            color: "#1C8CFF"
          }
        })]) : scope.row.fileStatus === _vm.DOWNLOAD_TASK_STATUS.map.generateFail.value ? _c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            placement: "bottom"
          }
        }, [_c("div", {
          attrs: {
            slot: "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(scope.row.remark))]), _vm._v(" "), _c("span", {
          staticStyle: {
            cursor: "pointer"
          }
        }, [_vm._v("查看失败原因")])]) : _vm._e()]];
      }
    }])
  })], 1)], 1)], 1);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

__vue_component__.install = function (Vue) {
  _newArrowCheck(this, _this19);

  Vue.prototype.$downloadCenter = DownloadTask$1;
  Vue.component(__vue_component__.name, __vue_component__);
}.bind(this);

export default __vue_component__;
